import { HexElementProperties } from '~/types/drill'
import { TOPIC_HEXAGON_PROPERTIES } from '~/shared/constants/drill.const'

export function getProperties(index: number): HexElementProperties {
  switch (index) {
    case 4:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
      }

    case 8:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: 'aqua',
        i18nKey: 'playAlt',
        splat: 'right',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 9:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.SOLUTION,
      }

    default:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.DEFAULT,
      }
  }
}
